var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import deepmerge from 'deepmerge';
import { propMerge } from '@shapeable/utils';
export var ComponentPropsContext = React.createContext({});
export var IconsComponentPropsProvider = function (props) {
  var existingProps = React.useContext(ComponentPropsContext) || {};
  var value = props.value,
    children = props.children;
  return React.createElement(ComponentPropsContext.Provider, {
    value: deepmerge(existingProps, value)
  }, children);
};
export var useAllComponentProps = function () {
  return React.useContext(ComponentPropsContext) || {};
};
export function useComponentProps(name, defaultComponentProps) {
  var overrides = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    overrides[_i - 2] = arguments[_i];
  }
  var allProps = useAllComponentProps();
  var componentContextProps = (allProps === null || allProps === void 0 ? void 0 : allProps[name]) || {};
  return propMerge.apply(void 0, __spreadArray([defaultComponentProps, componentContextProps], __read(overrides), false));
}
;
// alias
export var useComponentPropsFor = useComponentProps;